import { useState } from "react";
import { Eye, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function RevealEmail({ masked, onReveal, testId }) {
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);

  const reveal = async (e) => {
    e.stopPropagation();
    if (value || loading) return;
    setLoading(true);
    try {
      const full = await onReveal();
      setValue(full || masked);
    } catch (err) {
      if (err?.response?.status === 403) {
        toast.error("Unlock sensitive data in the Security tab to reveal emails.");
      } else {
        toast.error("Could not reveal email");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <span className="inline-flex items-center gap-1.5" data-testid={testId}>
      <span>{value || masked || "—"}</span>
      {!value && masked && (
        <button
          type="button"
          onClick={reveal}
          className="text-slate-400 hover:text-[#1E3A8A] transition-colors"
          title="Reveal full email"
          data-testid={testId ? `${testId}-btn` : undefined}
        >
          {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Eye className="w-3.5 h-3.5" />}
        </button>
      )}
    </span>
  );
}
